module.exports = __webpack_public_path__ + "img/UsgsGreenSymbol.06008ed4.svg";